import { default as FNS, logIn } from '../api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';



export const fetch = createAsyncThunk('drivers/fetch', async ({ id }, { dispatch }) => {
  try {

    const res = await FNS.getDriver(id);
    dispatch(driversSlice.actions.addDriver({ values: res }));
    
  } catch (e) {
    toast.error(e.message);
  }
});

export const fetchAll = createAsyncThunk('drivers/fetchAll', async (payload, { dispatch }) => {
  try {

    const res = await FNS.getDrivers();
    await dispatch(driversSlice.actions.replaceAll({ values: res }));
    
  } catch (e) {
    toast.error(e.message);
  }
});

export const ensureAll = createAsyncThunk('drivers/ensureAll', async (payload, { dispatch, getState }) => {
  try {
    const state = getState();

    if(state.drivers.haveAll) return;
  
    const res = await FNS.getDrivers();
    dispatch(driversSlice.actions.replaceAll({ values: res }));

  } catch (e) {
    toast.error(e.message);
  }
});

export const ensure = createAsyncThunk('drivers/ensure', async ({ id }, { dispatch, getState }) => {
  try {
    const state = getState();

    if(id in state.drivers.knownDrivers) return;
  
    const res = await FNS.getDriver(id);
    dispatch(driversSlice.actions.addDriver({ values: res }));

  } catch (e) {
    toast.error(e.message);
  }
});

export const toggleDriverHidden = createAsyncThunk('user/toggleDriverHidden', async ({ id, hidden }, { dispatch }) => {
  try {

    await FNS.toggleDriverHidden(id, hidden);
    await dispatch(fetch({ id }));

  } catch(e) {
    toast.error(e);
  }
});


const driversSlice = createSlice({
  name: 'drivers',
  initialState: {
    haveAll: false,
    knownDrivers: {}
  },
  reducers: {
    replaceAll: (state, { payload: { values } }) => {
      state.haveAll = true;
      let newDrivers = {};
      for(const driver of values) {
        newDrivers[driver.driver_id] = driver;
      }
      state.knownDrivers = newDrivers;
    },
    addDriver: (state, { payload: { values } }) => {
      for(const driver of values) {
        state.knownDrivers[driver.driver_id] = driver;
      }
    }
  },
});

export default driversSlice.reducer;
